import React, { useContext, useState, useEffect, useRef } from "react";
import { motion, AnimatePresence } from "framer-motion";
import YouTube from "react-youtube";
import { AmbientSoundContext, TONE_VIDEO_ID } from "../contexts/AmbientSoundContext";

const AmbientSoundPanel = () => {
  const [isOpen, setIsOpen] = useState(false);
  const autoCloseTimer = useRef(null);
  const { activeSound, volume, playSound, setAmbientVolume, tonePlayerRef } =
    useContext(AmbientSoundContext);

  useEffect(() => {
    if (isOpen) {
      autoCloseTimer.current = setTimeout(() => setIsOpen(false), 10000);
    }
    return () => {
      if (autoCloseTimer.current) clearTimeout(autoCloseTimer.current);
    };
  }, [isOpen]);

  const handleVolumeChange = (e) => {
    setAmbientVolume(parseInt(e.target.value, 10));
  };

  const sliderStyle = {
    background: `linear-gradient(to right, rgba(255,255,255,0.9) 0%, rgba(255,255,255,0.9) ${volume}%, rgba(255,255,255,0.2) ${volume}%, rgba(255,255,255,0.2) 100%)`,
  };

  const onTonePlayerReady = (event) => {
    tonePlayerRef.current = event.target;
    event.target.setVolume(volume);
  };

  const onTonePlayerEnd = (event) => {
    // Loop the video
    event.target.playVideo();
  };

  const getToggleIcon = () => {
    if (!activeSound) return "fa-volume-high";
    if (activeSound === "rain") return "fa-cloud-rain";
    return "fa-music";
  };

  return (
    <div className="ambient-panel">
      {/* Hidden YouTube player for tone ambient */}
      <div style={{ position: "absolute", width: 1, height: 1, overflow: "hidden", opacity: 0, pointerEvents: "none" }}>
        <YouTube
          videoId={TONE_VIDEO_ID}
          opts={{
            height: "1",
            width: "1",
            playerVars: {
              autoplay: 0,
              controls: 0,
              loop: 1,
              playlist: TONE_VIDEO_ID,
            },
          }}
          onReady={onTonePlayerReady}
          onEnd={onTonePlayerEnd}
        />
      </div>

      <AnimatePresence>
        {isOpen && (
          <motion.div
            className="ambient-panel-content"
            initial={{ opacity: 0, scale: 0.8, y: 10 }}
            animate={{ opacity: 1, scale: 1, y: 0 }}
            exit={{ opacity: 0, scale: 0.8, y: 10 }}
            transition={{ duration: 0.2, ease: "easeOut" }}
          >
            <div className="ambient-buttons">
              <button
                className={`ambient-btn ${activeSound === "rain" ? "active" : ""}`}
                onClick={() => playSound("rain")}
                title="Déšť"
              >
                <i className="fa-solid fa-cloud-rain"></i>
              </button>
              <button
                className={`ambient-btn ${activeSound === "tone" ? "active" : ""}`}
                onClick={() => playSound("tone")}
                title="Tóny"
              >
                <i className="fa-solid fa-music"></i>
              </button>
            </div>
            <input
              type="range"
              min="0"
              max="100"
              value={volume}
              onChange={handleVolumeChange}
              className="ambient-volume-slider"
              style={sliderStyle}
            />
          </motion.div>
        )}
      </AnimatePresence>

      <button
        className={`ambient-panel-toggle ${activeSound ? "active" : ""}`}
        onClick={() => setIsOpen(!isOpen)}
        title="Zvuky prostředí"
      >
        <i className={`fa-solid ${getToggleIcon()}`}></i>
      </button>
    </div>
  );
};

export default AmbientSoundPanel;
